import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2, Linkedin } from "lucide-react";
import { absoluteUrl } from "@/lib/site";
import { canonicalLink, hreflangLinks } from "@/lib/seo";

const BREVO_FORM_URL = "https://cd0ec557.sibforms.com/serve/MUIEAB7Ie94_jMA_hbDypyaTlJUBs3XwxLGfK_ln-0OBcV25V7yWvgsQw4YLw9u6viKQR7ECL4LUKGawBCGp2EVOaaRHm4Rcc2gv8Edxan-R9jehkiVoX0NGCpBgU56XWYY78NaMmqRu7HoLYwRDx-1TyUZL7zn1QIbQrSFWcl6ngwFelTkz8Lfk1vO2L0QHM9ktxkHi8-XliPQO";
const LINKEDIN_URL = "https://www.linkedin.com/company/smartlane-gmbh/";


const BENEFITS = [
  "Produkt-Updates",
  "Kunden-Insights und alles rund um Smartlane",
  "Einladungen zu Webinaren und Branchen-Events",
  "Alle zwei Monate – kein Spam",
];

export const Route = createFileRoute("/aktuelles/newsletter")({
  head: () => ({
    meta: [
      { title: "Newsletter | Smartlane" },
      { name: "description", content: "Alle zwei Monate: Releases, Insights und Events rund um KI-Tourenplanung. Jederzeit abbestellbar." },
      { property: "og:title", content: "Newsletter | Smartlane" },
      { property: "og:description", content: "Alle zwei Monate Smartlane-Insights in Ihr Postfach." },
      { property: "og:url", content: absoluteUrl("/aktuelles/newsletter") },
      { property: "og:type", content: "website" },
    ],
    links: [canonicalLink("/aktuelles/newsletter"), ...hreflangLinks("/aktuelles/newsletter")],
  }),
  component: NewsletterPage,
});

function NewsletterPage() {
  return (
    <>
      <section className="bg-rich-black text-white">
        <div className="container-wide pt-40 pb-24 lg:pt-48 lg:pb-32">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 backdrop-blur-md">
              <span className="h-2 w-2 rounded-full bg-smartlane-orange animate-pulse" />
              <span className="font-body text-xs uppercase tracking-[0.2em] text-white/80">NEWSLETTER</span>
            </div>
            <h1 className="text-display-xl mt-6 uppercase tracking-wider text-white leading-[0.95] max-w-6xl">
              ERHALTEN SIE ALLE ZWEI MONATE <span className="text-smartlane-orange">SMARTLANE INSIGHTS.</span>
            </h1>
            <p className="copy mt-8 text-lg text-white max-w-3xl">
              Sie möchten Neuigkeiten und Wissenswertes rund um aktuelle Logistikthemen und Smartlane direkt in Ihr E-Mail-Postfach bekommen? Melden Sie sich für unseren Newsletter an.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-24 lg:py-32">
        <div className="container-wide grid lg:grid-cols-2 gap-16 items-start max-w-5xl mx-auto">
          <ul className="space-y-4">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <CheckCircle2 className="h-5 w-5 text-smartlane-orange mt-1 shrink-0" />
                <span className="copy text-rich-black">{b}</span>
              </li>
            ))}
            <p className="pt-4 text-xs text-muted-foreground">
              Anmeldung im Double-Opt-In-Verfahren. Mehr in der{" "}
              <a href="/datenschutz" className="text-smartlane-orange underline">Datenschutzerklärung</a>.
            </p>
          </ul>

          <div className="rounded-2xl bg-white border border-border overflow-hidden shadow-sm">
            <iframe
              src={BREVO_FORM_URL}
              title="Newsletter-Anmeldung"
              className="w-full"
              style={{ minHeight: 820, border: 0 }}
              scrolling="no"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* LinkedIn Section */}
      <section className="relative bg-rich-black text-white border-t border-white/10 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-60">
          <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-smartlane-orange/10 blur-3xl" />
          <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-[#0A66C2]/20 blur-3xl" />
        </div>
        <div className="relative container-wide py-20 lg:py-28">
          <div className="max-w-3xl mx-auto text-center">
            <p className="eyebrow text-smartlane-orange">// SOCIAL MEDIA</p>
            <h2 className="font-heading text-3xl lg:text-5xl uppercase tracking-wide text-white mt-6">
              Bleiben Sie auch über <span className="text-smartlane-orange">LinkedIn</span> auf dem Laufenden.
            </h2>
            <p className="copy mt-6 text-white/70">
              Insights, Behind-the-Scenes, Produkt-Updates und Branchen-News – direkt in Ihrem Feed.
            </p>
            <div className="mt-8 flex justify-center">
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 rounded-full bg-[#0A66C2] hover:bg-[#0A66C2]/90 px-6 py-3 font-body text-sm font-semibold uppercase tracking-wider text-white transition-colors"
              >
                <Linkedin className="h-4 w-4" />
                Smartlane auf LinkedIn folgen
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

